import React, { useEffect, useState } from "react";
import {
  useLanguageActionContext,
  useLanguageContext,
} from "../../Context/LanguageContext";
import { useGlobalSpinnerActionsContext } from "../../Context/GlobalSpinnerContext";
import OrganisationSettingActions from "../../Actions/OrganisationSettingActions";
import organisationSettingStore from "../../Stores/OrganisationSettingStore";
import organisationSettingConstants from "../../Constants/OrganisationSettingConstants";
import commonUtils from "../../helpers/commonUtils";
import { useThemeActionsContext } from "../../Context/ThemeContext";

const EditSettingPopUp = (props) => {
  const {
    settingDetails,
    updateTheme,
    closeEditOrganisationSettingPopUpCallback,
  } = props;
  const [settingValue, setSettingValue] = useState("");
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const { localization } = useLanguageContext();
  const { UpdateLanguage } = useLanguageActionContext();
  //const updateTheme = useThemeActionsContext();

  const closeEditOrganisationSettingPopUp = () => {
    closeEditOrganisationSettingPopUpCallback();
  };

  function editOrganisationSettingSubmit(e) {
    e.preventDefault();
    const settingData = {
      Name: props.settingDetails.settingName,
      Value: settingValue,
    };
    setGlobalSpinner(true);
    OrganisationSettingActions.SaveUpdateOrganisationSetting(settingData);
    if (props.settingDetails.settingName === "Theme") {
      sessionStorage.setItem("theme", settingValue);
      updateTheme(settingValue);
    }
    if (props.settingDetails.settingName === "Language") {
      UpdateLanguage(settingValue);
    }
  }

  useEffect(() => {
    if (props.settingDetails) {
      setSettingValue(props.settingDetails.value);
    }
    return () => {};
  }, [props]);

  return (
    <div
      className="modal fade"
      id="editOrganisationSetting"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="editOrganisationSetting"
      aria-hidden="true"
      data-backdrop="static"
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="editOrganisationSettingTitle">
              {localization.editSetting}
            </h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              id="editOrganisationSettingModalClose"
              onClick={closeEditOrganisationSettingPopUp}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <form
            id="editOrganisationSettingForm"
            name="editOrganisationSettingForm"
            onSubmit={editOrganisationSettingSubmit}
          >
            {" "}
            <div className="modal-body">
              <div className="row">
                <div className="col">
                  <div className="form-group">
                    <label
                      className="form-label"
                      htmlFor={props.settingDetails.settingName}
                    >
                      {props.settingDetails.displayText}
                    </label>
                    {props.settingDetails.options?.length > 0 ? (
                      <select
                        className="form-control"
                        id={props.settingDetails.settingName}
                        name={props.settingDetails.settingName}
                        value={settingValue ? settingValue : ""}
                        required
                        onChange={(e) => {
                          setSettingValue(e.target.value);
                        }}
                      >
                        <option value="" disabled>
                          Select
                        </option>
                        {props.settingDetails.options.map((option, index) => {
                          return (
                            <option key={index} value={option.value}>
                              {option.text}
                            </option>
                          );
                        })}
                      </select>
                    ) : (
                      <input
                        type="text"
                        id={props.settingDetails.settingName}
                        name={props.settingDetails.settingName}
                        className="form-control"
                        placeholder=""
                        value={settingValue ? settingValue : ""}
                        onChange={(e) => {
                          setSettingValue(e.target.value);
                        }}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <div className="form-group">
                <button
                  type="submit"
                  className="btn btn-primary btn-block mb-4"
                >
                  {localization.save}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EditSettingPopUp;
